// HamburgerButton.js
import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 1.5rem;
  height: 1.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;

  &:focus {
    outline: none;
  }

  div {
    width: 1.5rem;
    height: 0.2rem;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    /* Using isOpen prop to control background color */
    background: ${({ $isOpen }) => ($isOpen ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.95)')};

    :first-child {
      /* Rotate the first div based on the isOpen prop */
      transform: ${({ $isOpen }) => ($isOpen ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      /* Hide the second div when open */
      opacity: ${({ $isOpen }) => ($isOpen ? '0' : '1')};
      transform: ${({ $isOpen }) => ($isOpen ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      /* Rotate the third div based on the isOpen prop */
      transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }

  &:hover div {
    background: rgba(255, 255, 255, 1);
  }
`;

const HamburgerButton = ({ isOpen, toggle }) => {
  return (
    <Button $isOpen={isOpen} onClick={toggle}>
      <div />
      <div />
      <div />
    </Button>
  );
};

export default HamburgerButton;
